<agr-page-detail
  [pageTitle]="pageTitle$ | async"
  data-test="create-reference-scheme__detail"
  (backAction)="back()"
  [hasPrimaryAction]="(viewMode$ | async) !== viewModes.View"
  primaryActionIcon="save"
  [primaryActionText]="'save' | translate"
  (primaryAction)="save()"
>
  <div class="spacing--margin-horizontal spacing--margin-top">
    <form [formGroup]="referenceSchemeGroup">
      <div class="spacing--margin-top flex--row flex--wrap">
        <div
          *ngIf="(viewMode$ | async) !== viewModes.View"
          class="flex--column spacing--margin-left field-width"
        >
          <mat-form-field class="flex__child--auto">
            <input
              matInput
              formControlName="name"
              placeholder="{{ 'reference-scheme.create.name' | translate }}"
              data-test="create-reference-scheme__name"
            />
            <mat-error *ngIf="referenceSchemeGroup.controls.name.invalid">
              {{ 'reference-scheme.create.error-name' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="flex--column spacing--margin-left">
          <p class="text--small">
            <strong>{{ 'reference-scheme.create.created' | translate }}:</strong>
            {{ referenceScheme.created | agrDate }} - {{ referenceScheme.createdAdvisorName }}
          </p>
        </div>
        <div class="flex--column spacing--margin-left">
          <p class="text--small">
            <strong>{{ 'reference-scheme.create.updated' | translate }}:</strong>
            {{ referenceScheme.updated | agrDate }} - {{ referenceScheme.updatedAdvisorName }}
          </p>
        </div>
      </div>

      <h3 class="text--h3">{{ 'feed-advice.create.products' | translate }}</h3>
      <!-- table -->
      <agr-table [config]="tableConfig"></agr-table>
      <ng-template #productNameTemplate let-row="row">
        <mat-select
          [hideSingleSelectionIndicator]="true"
          *ngIf="(viewMode$ | async) === viewModes.Create || (viewMode$ | async) === viewModes.Edit"
          class="text--small"
          [value]="getProduct(row)"
          placeholder="{{ 'reference-scheme.create.product-placeholder' | translate }}"
          (selectionChange)="selectProduct($event, row)"
          data-test="create-reference-scheme__productrows_product-selector"
        >
          <mat-option *ngFor="let product of products$ | async" [value]="product">
            {{ product.code }} - {{ product.name }}
          </mat-option>
        </mat-select>
        <span *ngIf="(viewMode$ | async) === viewModes.View">
          {{ row.product.code }} - {{ row.product.name }}</span
        >
      </ng-template>

      <div class="flex--column" *ngIf="(viewMode$ | async) !== viewModes.View">
        <div class="mat-button-row spacing--margin-top">
          <button
            type="button"
            mat-flat-button
            color="primary"
            data-test="create-reference-scheme__add-product"
            (click)="addProductRow()"
          >
            {{ 'reference-scheme.create.add-product' | translate }}
          </button>
        </div>
      </div>

      <app-additive
        [viewMode]="viewMode$ | async"
        [isReferenceFeedAdvice]="true"
        [referenceFeedAdvice]="referenceScheme"
        [additives$]="additives$"
        (additiveChanged)="updateAdditiveRows($event)"
        (showAdditiveChanged)="updateShowAdditiveRows($event)"
        class="spacing--margin-bottom"
      >
      </app-additive>

      <div class="spacing--padding-top"></div>

      <agr-summary-card
        [title]="'reference-scheme.create.description' | translate"
        [canExpand]="true"
        [actions]="[]"
      >
        <textarea
          *ngIf="(viewMode$ | async) !== viewModes.View"
          class="text--small remarks__field"
          label="description"
          formControlName="description"
          rows="3"
          placeholder="{{ 'reference-scheme.create.description-placeholder' | translate }}"
          data-test="create-reference-scheme__description"
        ></textarea>
        <span *ngIf="(viewMode$ | async) === viewModes.View">
          <pre>{{ referenceScheme?.description }}</pre>
        </span>
      </agr-summary-card>
    </form>
  </div>
</agr-page-detail>
